<div class="mat-dialog-container">
  <!-- 明細編輯開始 -->
  <div #head>
    <app-modal-header #modal_header [isDialog]="isDialog" [title]="title" [state]="srv.state" (onOkClick)="doOk($event)"
      (onCancelClick)="doCancel($event)">
    </app-modal-header>
  </div>
  <div class="jk-content">
    <div class="jk-grid-cols-4"> 
    <app-jktext  label="序號" [value]="item.MD003"     >
    </app-jktext>
    <app-jkedit  label="類別" #MD004Com  id="MD004"  [(value)]="item.MD004" placeholder="類別"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="帳號" #MD006Com  id="MD006"  [(value)]="item.MD006" placeholder="帳號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="密碼" #MD007Com  id="MD007"  [(value)]="item.MD007" placeholder="密碼"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkdatefield  label="日期" #MD008Com  id="MD008"  [(value)]="item.MD008" placeholder="日期"  [readonly]="isBrowse" 
            >
    </app-jkdatefield>
    <app-jkedit  label="網址" #MD009Com  id="MD009"  [(value)]="item.MD009" placeholder="網址"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="資料" #MD010Com  id="MD010"  [(value)]="item.MD010" placeholder="資料"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jktextarea  height="250px" 
 label="備註" #MD005Com  id="MD005"  [(value)]="item.MD005" placeholder="備註"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jkedit  label="流水號" #MD002Com  id="MD002"  [(value)]="item.MD002" [required]="true"  placeholder="流水號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="customId" #MD011Com  id="MD011"  [(value)]="item.MD011" [required]="true"  placeholder="customId"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="編號" #MD001Com  id="MD001"  [(value)]="item.MD001" [required]="true"  placeholder="編號"  [readonly]="isBrowse"     >
    </app-jkedit>

    </div>
  </div>
</div>